import { Skeleton, Tooltip } from '@heroui/react';

import { CopyableText } from '~/components/CopyableText';
import { useTruncatedTooltip } from '~/components/TruncatedText';

type PipelineKeyCellProps = {
  pipelineKey: string;
};

export function PipelineKeyCell({ pipelineKey }: PipelineKeyCellProps) {
  const { ref, isTruncated } = useTruncatedTooltip(pipelineKey);

  if (!pipelineKey) return <span>-</span>;

  return (
    <CopyableText
      text={pipelineKey}
      className='whitespace-normal text-left font-mono text-body-regular-md lg:min-w-[142px] xl:min-w-[172px] 3xl:w-[336px]'
      data-testid='monitor-pipeline-logs-cell-execution-key'
    >
      <Tooltip isDisabled={!isTruncated} content={pipelineKey}>
        <p
          ref={ref as React.RefObject<HTMLParagraphElement>}
          className='line-clamp-1 break-all'
        >
          {pipelineKey}
        </p>
      </Tooltip>
    </CopyableText>
  );
}

export function PipelineKeyCellSkeleton() {
  return (
    <Skeleton className='h-5 lg:w-[120px] xl:w-[150px] 3xl:w-[358px] rounded' />
  );
}
